const MARKETING_ORIGIN = 'https://personicai.com';
const PORTAL_ORIGIN = 'https://app.personicai.com';
const CONSUMER_ORIGIN = 'https://my.personicai.com';

export function redirectToPortal(path: string = '/dashboard') {
  window.location.href = `${PORTAL_ORIGIN}${path}`;
}

export function redirectToLogin(returnTo?: string) {
  const params = returnTo ? `?returnTo=${encodeURIComponent(returnTo)}` : '';
  window.location.href = `${MARKETING_ORIGIN}/auth/signin${params}`;
}

export function getReturnToUrl(): string | null {
  return new URLSearchParams(window.location.search).get('returnTo');
}

export function isPortalDomain(): boolean {
  return window.location.hostname === 'app.personicai.com';
}

export function isMarketingDomain(): boolean {
  const h = window.location.hostname;
  return h === 'personicai.com' || h === 'www.personicai.com';
}

export function redirectToConsumerPortal(path: string = '/dashboard') {
  window.location.href = `${CONSUMER_ORIGIN}${path}`;
}

export function isConsumerDomain(): boolean {
  return window.location.hostname === 'my.personicai.com';
}
